import '../css/Addresses.css'
import { useState, useEffect } from 'react';
import CircularIndeterminate from '../components/CircularLoad';
import SessionAlert from '../components/SessionAlert';
import SimpleAlert from '../components/SimpleAlert';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import HomeIcon from '@mui/icons-material/Home';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import { responseArray, authHeaders } from '../utils/apiFetch';
import useCsrfToken from '../useCsrfToken';

export default function Addresses(){
    const [addresses, setAddresses] = useState(null);
    const [phoneNb, setPhoneNb] = useState(null);
    const [loading, setLoading] = useState(true);
    const [alertMsg, setAlertMsg] = useState('');
    const [alertType, setAlertType] = useState('');
    const csrfToken = useCsrfToken();

    useEffect(() => {
        fetchAddresses();
    }, []);

    const fetchAddresses = async () => {
        try {
            const response = await fetch('/api/user/addresses', {
                headers: authHeaders()
            });
            const data = await response.json();
            if (data.success) {
                setLoading(false);
                setAddresses(responseArray(data, 'addresses'));
                setPhoneNb(data.phoneNb)
            } else {
                // setError('Failed to fetch products.');
                setAddresses([]);
            }
        } catch (error) {
            // setError('Failed to fetch products.');
            setAddresses([]);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (index) => {
        try {
            const response = await fetch(`/api/user/addresses/${index}`, {
                method: "DELETE",
                headers: authHeaders({})
            });
            const data = await response.json();
            setAlertMsg(data.message)
            if (data.success) {
                setAlertType('success');
                fetchAddresses();
            } else {
                setAlertType('error');
            }
        } catch (error) {
            setAlertMsg("An error occured")
            setAlertType('error');
        }
    };

    if(addresses === null) {
        return (
            <div id="secondary-loading">
                <CircularIndeterminate display={true}/>
            </div>
        )
    }

    return (
        <div className='parent-container'>
            <SessionAlert/>
            <SimpleAlert message={alertMsg} type={alertType} display={alertMsg !== '' ? 'block' : 'none'}/>
            <div className="addresses-header">
                <div>
                    <h2>Saved addresses</h2>
                    <p>Manage the delivery locations linked to your account.</p>
                </div>
                <a href="/user/add-address" className="addresses-header-action">
                    <AddIcon fontSize="small" />
                    Add address
                </a>
            </div>
            <section id='addresses-container'>
                {addresses && addresses.map((address, index) => (
                <article className="address-card" key={`${address.city}-${address.street}-${index}`}>
                    <div className="address-card-top">
                        <div className="address-icon">
                            <HomeIcon fontSize="small" />
                        </div>
                        <div>
                            <h3>Address {index + 1}</h3>
                            <p>{address.city}</p>
                        </div>
                    </div>
                    <div className="address-details">
                        <div className="address-detail-row">
                            <LocationOnIcon fontSize="small" />
                            <span>{address.street}</span>
                        </div>
                        <div className="address-detail-row">
                            <HomeIcon fontSize="small" />
                            <span>Building {address.building}</span>
                        </div>
                        <div className="address-detail-row">
                            <PhoneIcon fontSize="small" />
                            <span>{phoneNb}</span>
                        </div>
                    </div>
                    <div className='address-actions'>
                        <a href={`/user/address/${index}`} className="address-action address-action-edit">
                            <EditIcon fontSize="small" />
                            Edit
                        </a>
                        <button className="address-action address-action-delete" onClick={()=>handleDelete(index)}>
                            <DeleteIcon fontSize="small" />
                            Delete
                        </button>
                    </div>
                </article>
                ))}
                <a href="/user/add-address" className="add-address-card">
                    <div className='add-address-icon'>
                        <AddIcon />
                    </div>
                    <h3>New address</h3>
                    <p>Add another delivery location</p>
                </a>
            </section>
        </div>
    )
}
